import { theme } from '../theme';
import React from 'react';
import Switch from 'react-switch';
import styled from 'styled-components';

type IProps = {
  on: boolean;
  onChange: (on: boolean) => void;
  onColor?: string;
  offColor?: string;
  height?: number;
  className?: string;
  disabled?: boolean;
};
const CustomSwitchWrapper = styled.span`
  .custom-toggle-switch {
    cursor: pointer;
    margin-top: 7px !important;
    .react-switch-handle {
      top: -1px !important;
      border: 3px solid #fff !important;
      transition: left 0.2s ease-in-out;
    }
  }
  .small-toggle-switch {
    .react-switch-bg {
      height: 10px !important;
      width: 30px !important;
    }
    .react-switch-handle {
      top: 3px !important;
      height: 20px !important;
      width: 20px !important;
    }
  }
`;

const ToggleSwitch: React.FC<IProps> = ({ on, onChange, onColor, offColor, height = 14, className, disabled }) => {
  return (
    <CustomSwitchWrapper>
      <Switch
        checked={on}
        onChange={on => !disabled && onChange(on)}
        onColor={onColor || theme.palette.success.dark}
        onHandleColor={onColor || theme.palette.success.dark}
        offColor={offColor || theme.palette.danger.dark}
        offHandleColor={offColor || theme.palette.danger.dark}
        handleDiameter={26}
        uncheckedIcon={false}
        checkedIcon={false}
        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
        height={height}
        width={38}
        className={`custom-toggle-switch ${className}`}
        id="material-switch"
        disabled={disabled}
      />
    </CustomSwitchWrapper>
  );
};

export default ToggleSwitch;
